var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.item.hidden && _vm.item.children
    ? _c(
        "div",
        { staticClass: "menu-wrapper" },
        [
          _vm.hasOneShowingChild(_vm.item.children) &&
          !_vm.onlyOneChild.children &&
          !_vm.item.alwaysShow
            ? _c(
                "div",
                {
                  on: {
                    click: function ($event) {
                      return _vm.clickNext(_vm.onlyOneChild)
                    },
                  },
                },
                [
                  _c(
                    "el-menu-item",
                    {
                      class: { "submenu-title-noDropdown": !_vm.isNest },
                      attrs: { index: _vm.resolvePath(_vm.onlyOneChild.path) },
                    },
                    [
                      _vm.onlyOneChild.meta && _vm.onlyOneChild.meta.icon
                        ? _c("svg-icon", {
                            attrs: { "icon-class": _vm.onlyOneChild.meta.icon },
                          })
                        : _vm._e(),
                      _vm.onlyOneChild.meta && _vm.onlyOneChild.meta.title
                        ? _c(
                            "span",
                            { attrs: { slot: "title" }, slot: "title" },
                            [
                              _vm._v(
                                _vm._s(_vm.$t(_vm.onlyOneChild.meta.title))
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c(
                "el-submenu",
                { attrs: { index: _vm.item.name || _vm.item.path } },
                [
                  _c(
                    "template",
                    { slot: "title" },
                    [
                      _vm.item.meta && _vm.item.meta.icon
                        ? _c("svg-icon", {
                            attrs: { "icon-class": _vm.item.meta.icon },
                          })
                        : _vm._e(),
                      _vm.item.meta && _vm.item.meta.title
                        ? _c(
                            "span",
                            { attrs: { slot: "title" }, slot: "title" },
                            [_vm._v(_vm._s(_vm.$t(_vm.item.meta.title)))]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._l(_vm.item.children, function (child) {
                    return !child.hidden
                      ? [
                          child.children && child.children.length > 0
                            ? _c("sidebar-item", {
                                key: child.path,
                                staticClass: "nest-menu",
                                attrs: {
                                  "is-nest": true,
                                  item: child,
                                  "base-path": _vm.resolvePath(child.path),
                                },
                              })
                            : _c(
                                "router-link",
                                {
                                  key: child.name,
                                  attrs: { to: _vm.resolvePath(child.path) },
                                },
                                [
                                  _c(
                                    "el-menu-item",
                                    {
                                      attrs: {
                                        index: _vm.resolvePath(child.path),
                                      },
                                    },
                                    [
                                      child.meta && child.meta.icon
                                        ? _c("svg-icon", {
                                            attrs: {
                                              "icon-class": child.meta.icon,
                                            },
                                          })
                                        : _vm._e(),
                                      child.meta && child.meta.title
                                        ? _c(
                                            "span",
                                            {
                                              attrs: { slot: "title" },
                                              slot: "title",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t(child.meta.title))
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                        ]
                      : _vm._e()
                  }),
                ],
                2
              ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }